import { getCookieByName } from './general';
export var newrelic = {
    setCustomAttribute: function (name, value) {
        var _a;
        if (((_a = window.newrelic) === null || _a === void 0 ? void 0 : _a.setCustomAttribute) instanceof Function) {
            window.newrelic.setCustomAttribute(name, value);
        }
    },
    addPageAction: function (name, value) {
        var _a;
        if (((_a = window.newrelic) === null || _a === void 0 ? void 0 : _a.addPageAction) instanceof Function) {
            window.newrelic.addPageAction(name, value);
        }
    },
};
export var setNewRelicQuantumMetricsAttributes = function () {
    var qmSessionID = getCookieByName('QuantumMetricSessionID');
    var qmUserId = getCookieByName('QuantumMetricUserID');
    if (qmSessionID && qmUserId) {
        newrelic.setCustomAttribute('QMSessionId', qmSessionID);
        newrelic.setCustomAttribute('QMUserId', qmUserId);
    }
};
